<template>
  <v-card
    class="text-wrap"
    max-width="350"
    elevation="24"
    tile
    :color="cardColor"
  >
    <b-button
      v-if="canManageRoster && rosterStatusApiReady"
      :variant="workingFlagVariant"
      class="workingTag"
      style="font-size: 11px"
      v-b-tooltip.hover
      :title="workingTooltip"
      v-on:click.stop="toggleWorking"
    >
      {{ workingLabel }}
    </b-button>
    <br />
    <div
      class="img-circle"
      :style="{'background-image': 'url(' + `${getImage}` + ')'}"
    ></div>
    <v-card-title>
      <h3>{{ team.full_name }}</h3>
    </v-card-title>
    <v-card-title>
      <h5>{{ team.email_address }}</h5>
    </v-card-title>
    <v-card-subtitle
      v-if="canManageRoster && !isCurrentlyWorking && lastWorkingLabel"
      class="white--text"
    >
      Last day: {{ lastWorkingLabel }}
    </v-card-subtitle>
    <v-card-subtitle
      v-if="canManageRoster && isCurrentlyWorking && stintStartLabel"
      class="white--text"
    >
      Stint from: {{ stintStartLabel }}
    </v-card-subtitle>
    <v-card-actions class="wrap_buttons">
      <b-button
        v-if="team.publish"
        variant="success"
        class="publishTag"
        style="font-size: 11px"
        v-b-tooltip.hover
        title="This Card is Published click to Un publish"
        v-on:click="togglePublish"
        >Published
      </b-button>
      <b-button
        v-else
        v-b-tooltip.hover
        title="This Card is Not Published click to Publish"
        v-on:click="togglePublish"
        variant="danger"
        class="publishTag"
        style="font-size: 11px"
        >Not Published
      </b-button>
    </v-card-actions>
    <v-card-actions class="wrap_buttons">
      <v-btn
        color="purple"
        class="ml-2 mt-1"
        v-on:click="linkToProfile"
        v-b-modal="modalId"
      >
        <v-icon left> mdi-information </v-icon>View Details</v-btn
      >
      <v-btn
        color="blue"
        class="mt-1"
        v-on:click="goToTeamDetail"
        v-b-modal="editModalId"
      >
        <v-icon left> mdi-pen </v-icon>
        Edit Card</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn icon @click="showDetail">
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>
        <v-card-text
          ><b-jumbotron
            >Description:
            {{ team.description_of_member }}
          </b-jumbotron></v-card-text
        >
        <v-card-actions> </v-card-actions>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {userCanManageTeamRosterStatus} from "@/Utilites/teamRosterAdmin";
import {formatLastWorkingDateLabel} from "@/utils/memberEmploymentDates";
import {teamRosterStatusSupported} from "@/Utilites/teamRosterApi";
export default {
  name: "TeamTopCard",
  props: ["id", "team", "modalId", "editModalId", "publishFlag"],
  data() {
    return {
      show: false,
      display: {},
    };
  },
  computed: {
    ...mapGetters(["getToken", "userProfileData", "getTeamList"]),
    canManageRoster() {
      return userCanManageTeamRosterStatus(this.userProfileData);
    },
    rosterStatusApiReady() {
      return teamRosterStatusSupported(this.getTeamList);
    },
    isCurrentlyWorking() {
      return this.team.is_currently_working !== false;
    },
    workingLabel() {
      return this.isCurrentlyWorking ? "Working" : "Not working";
    },
    workingFlagVariant() {
      return this.isCurrentlyWorking ? "success" : "warning";
    },
    workingTooltip() {
      return this.isCurrentlyWorking
        ? "Click to mark as not currently working (hidden from most users)"
        : "Click to mark as currently working";
    },
    lastWorkingLabel() {
      return formatLastWorkingDateLabel(this.team.last_working_date);
    },
    stintStartLabel() {
      return formatLastWorkingDateLabel(
        this.team.current_employment_start_date
      );
    },
    cardColor() {
      if (this.canManageRoster && !this.isCurrentlyWorking) {
        return "grey darken-2";
      }
      return this.team.publish ? "green" : "grey";
    },
    getImage() {
      let img = this.team.avatar_url;
      if (this.team.avatar_url === "" || this.team.avatar_url === null) {
        img = require("@/assets/image/NekologicSquare.png");
      }
      return img;
    },
  },
  methods: {
    ...mapActions([
      "toggleMemberPublishFlag",
      "toggleMemberWorkingFlag",
      "fetchTeamList",
      "showSnackBar",
    ]),
    linkToProfile() {
      this.$router.push({name: "MemberInfo", params: {userId: this.team.id}});
    },
    goToTeamDetail() {
      const team = this.team;
      this.$emit("child-to-parent-teams", team);
    },
    showDetail() {
      this.show = !this.show;
    },
    togglePublish() {
      const memberId = this.team.id;
      const publish = !this.publishFlag;
      this.display.publish = publish;
      this.toggleMemberPublishFlag({memberId, publish});
    },
    async toggleWorking() {
      if (!this.canManageRoster) return;
      const memberId = this.team.id;
      const isCurrentlyWorking = !this.isCurrentlyWorking;
      try {
        await this.toggleMemberWorkingFlag({memberId, isCurrentlyWorking});
        await this.showSnackBar({
          text: isCurrentlyWorking
            ? `${this.team.full_name} marked as currently working`
            : `${this.team.full_name} marked as not currently working`,
          color: "success",
        });
      } catch (err) {
        const detail =
          (err.response && err.response.data && err.response.data.detail) ||
          err.message ||
          "Could not update roster status (is nekoapi migration 0058 deployed?)";
        await this.showSnackBar({text: String(detail), color: "error"});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  cursor: pointer;
}
.card {
  width: 15rem;
  flex: none;
  position: relative;
}
.publishTag {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 0.8rem;
  padding: 0.4rem 0.75rem;
}
.workingTag {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 0.8rem;
  padding: 0.4rem 0.75rem;
  z-index: 1;
}
.img-circle {
  border-radius: 50%;
  margin: auto;
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: cover;
  height: 0;
  width: 95%;
  padding-bottom: 95%;
}
.imgCard {
  margin: 0;
  max-width: 15rem;
  height: 150px;
  object-fit: cover;
}
.wrap_buttons {
  display: flex;
  flex-wrap: wrap;
}
</style>
